import './EventsBoxResults.scss';
import template from './EventsBoxResults.vhtml';

export default {
	name: 'EventsBoxResults',
	template: template,
	props: {
		search: {
			type: String,
			default: '',
		},
		topics: {
			type: [Number, String],
			default: '',
		},
	},
};
